import React, { FunctionComponent } from 'react';
import styles from './latest-articles.module.scss';
import { ArticleListItem } from '../blog/article-list-item/article-list-item';
import {
  SectionHeader,
  ISectionHeaderProps
} from '../section-header/section-header';
import { Button, IButtonProps } from '../button/button';
import classNames from 'classnames/bind';

export interface ILatestArticlesProps {
  articles: IBlogArticle[];
  header: ISectionHeaderProps;
  seeMoreButton: IButtonProps;
  additionamMarginInColumn: string;
  additionamMarginInRow: string;
  backgroundColor: string;
  id: string;
}

const cx = classNames.bind(styles);

export const LatestArticles: FunctionComponent<ILatestArticlesProps> = ({
  articles,
  header,
  seeMoreButton,
  additionamMarginInColumn,
  additionamMarginInRow,
  backgroundColor,
  id
}) => {
  const wrapperClass = cx({
    backgroundColorPrimary: backgroundColor === 'primary',
    backgroundColorWhite: backgroundColor === 'white',
    backgroundColorSecondary: backgroundColor === 'secondary',
    backgroundColorLightGray: backgroundColor === 'light_gray',
    backgroundColorTransparent: backgroundColor === 'transparent',
    wrapper: true
  });

  const containerClass = cx({
    marginSmallColumn: additionamMarginInColumn === 'small',
    marginMediumColumn: additionamMarginInColumn === 'medium',
    marginLargeColumn: additionamMarginInColumn === 'large',
    marginExtraLargeColumn: additionamMarginInColumn === 'extra_large',
    marginSmallRow: additionamMarginInRow === 'small',
    marginMediumRow: additionamMarginInRow === 'medium',
    marginLargeRow: additionamMarginInRow === 'large',
    marginExtraLargeRow: additionamMarginInRow === 'extra_large'
  });

  return (
    <section id={id} className={wrapperClass}>
      <div className={`${styles.container}`}>
        <div className={containerClass}>
          <div className={styles.header}>
            <SectionHeader {...header} />
          </div>
          <div className={styles.articlesWrapper}>
            {articles &&
              articles.map((article: IBlogArticle, i: number) => (
                <ArticleListItem data={article} key={i} />
              ))}
          </div>
          <div className={styles.seeMoreButton}>
            <Button {...seeMoreButton} />
          </div>
        </div>
      </div>
    </section>
  );
};
